export type NavItem = {
  label?: string;
  path: string;
  testId: string;
};

export type DesktopNav = {
  logoUrl: string;
  tabItems: NavItem[];
};

export type TabConfig = {
  [key: string]: NavItem[];
};

export enum UserType {
  Default = 'default',
  FixedWireless = 'fixedWireless',
  Fiber = 'fiber',
}
